var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Margin } from '../core/appearance';
import { Property, Complex, ChildProperty } from '@syncfusion/ej2-base';
/**
 * Defines the configuration settings for flowchart automatic layout
 */
export class FlowchartLayoutSettings extends ChildProperty {
}
__decorate([
    Property('LeftInFlow')
], FlowchartLayoutSettings.prototype, "yesBranchDirection", void 0);
__decorate([
    Property('RightInFlow')
], FlowchartLayoutSettings.prototype, "noBranchDirection", void 0);
__decorate([
    Property(['Yes', 'True'])
], FlowchartLayoutSettings.prototype, "yesBranchValues", void 0);
__decorate([
    Property(['No', 'False'])
], FlowchartLayoutSettings.prototype, "noBranchValues", void 0);
/**
 * Defines the behavior of the automatic layouts
 */
export class Layout extends ChildProperty {
}
__decorate([
    Property('')
], Layout.prototype, "fixedNode", void 0);
__decorate([
    Property(30)
], Layout.prototype, "horizontalSpacing", void 0);
__decorate([
    Property('SamePoint')
], Layout.prototype, "connectionPointOrigin", void 0);
__decorate([
    Property('Nonlinear')
], Layout.prototype, "arrangement", void 0);
__decorate([
    Property(30)
], Layout.prototype, "verticalSpacing", void 0);
__decorate([
    Property(30)
], Layout.prototype, "maxIteration", void 0);
__decorate([
    Property(40)
], Layout.prototype, "springFactor", void 0);
__decorate([
    Property(50)
], Layout.prototype, "springLength", void 0);
__decorate([
    Complex({ left: 50, top: 50, right: 0, bottom: 0 }, Margin)
], Layout.prototype, "margin", void 0);
__decorate([
    Property('Auto')
], Layout.prototype, "horizontalAlignment", void 0);
__decorate([
    Property('Auto')
], Layout.prototype, "verticalAlignment", void 0);
__decorate([
    Property('TopToBottom')
], Layout.prototype, "orientation", void 0);
__decorate([
    Property('Auto')
], Layout.prototype, "connectionDirection", void 0);
__decorate([
    Property('Default')
], Layout.prototype, "connectorSegments", void 0);
__decorate([
    Property('None')
], Layout.prototype, "type", void 0);
__decorate([
    Property()
], Layout.prototype, "getLayoutInfo", void 0);
__decorate([
    Property()
], Layout.prototype, "layoutInfo", void 0);
__decorate([
    Property()
], Layout.prototype, "getBranch", void 0);
__decorate([
    Property()
], Layout.prototype, "bounds", void 0);
__decorate([
    Property(true)
], Layout.prototype, "enableAnimation", void 0);
__decorate([
    Property(false)
], Layout.prototype, "enableRouting", void 0);
__decorate([
    Property('')
], Layout.prototype, "root", void 0);
__decorate([
    Complex({}, FlowchartLayoutSettings)
], Layout.prototype, "flowchartLayoutSettings", void 0);
